const domain = process.env.REACT_APP_BACKEND_PATH;
const domainFiles = process.env.REACT_APP_BACKEND_PATH_FILES;
const wsDomain = process.env.REACT_APP_BACKEND_PATH_WEBSOCKET;

const account = domain + "/account/";
const proxy = {
  plain: domain,
  plainFiles: domainFiles,
  wsPlain: wsDomain,
  account,
  facilityVerification: `${account}facility_verification/`,
  termsAcceptance: `${account}terms_acceptance/`,
  cv: domain + "/cv/",
  job: domain + "/job/",
  blog: domain + "/blog/",
  notification: domain + "/notification/",
  wsNotification: wsDomain + "/notification/",
  chat: domain + "/chat/",
  wsChat: wsDomain + "/chat/",
  steps: domain + "/steps/",
  videos: domain + "/videos/",
  contact: domain + "/helpline/",
  menu: domain + "/tiles/",
  experts: domain + "/experts/",
  workshops: domain + "/workshops/",
  external: domain + "/external/api-keys/",
  contactFoundation: domain + "/contact/",
  events: domain + "/events/",
};

export default proxy;
